import { default as i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
// Export bridge so that consumers doesn't import their own i18next instance and have access to the types of i18next
export * from 'i18next';
const SUPPORTED_COMMON_NAMESPACES = new Set(['validation', 'enum']);
export const initializeI18N = (additionalNamespaces = []) => i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(ChainedBackend)
    .init({
    load: 'currentOnly',
    fallbackLng: 'fr',
    returnNull: false,
    returnObjects: true,
    debug: false,
    supportedLngs: ['fr', 'en'],
    interpolation: {
        escapeValue: false,
    },
    ns: ['translation', ...SUPPORTED_COMMON_NAMESPACES, ...additionalNamespaces],
    backend: {
        backends: [
            // First lookup in @if/core for SUPPORTED_COMMON_NAMESPACES
            resourcesToBackend((language, namespace) => {
                if (SUPPORTED_COMMON_NAMESPACES.has(namespace)) {
                    return import(`../../locales/${language}/${namespace}.json`).catch((e) => {
                        console.error(`Failed to load ${namespace} for ${language}`, e);
                    });
                }
                return Promise.resolve({});
            }),
            // If namespace not supported, fallback to the consumer public folder
            HttpBackend,
        ],
    },
});
export default i18n;
